import type { PatientDetail } from '#shared/types';
import { ResourceFormShell } from '#client/components/ui/ResourceFormShell';
import { RESOURCE } from '#client/lib/routes';
import { PatientForm } from './PatientForm';

export function PatientEditPage() {
  return (
    // `fullWidth` matches the registration screen; at a narrower width the same
    // form's two-column layout would collapse on one route and not the other.
    <ResourceFormShell<PatientDetail> path={RESOURCE.patients} noun="patient" fullWidth>
      {({ id, record }) => <PatientForm id={id} record={record} />}
    </ResourceFormShell>
  );
}
